export default __webpack_public_path__ + "static/Tek_Wall-836d7efb91c7eef83b820bcb23eeda31.png";